import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'
import useStyles from './Subtitle.style.js'
import { Typography } from '@material-ui/core'

/**
 * A page subtitle with a decorator on the left, similar to a `<Callout />`
 */
const Subtitle = (props) => {
  const { children, color, hLevel, bottomMargin, allCaps, style } = props
  const classes = useStyles()

  const h = hLevel <= 6 ? hLevel : 6

  return (
    <Grid
      container
      className={classNames(classes.container, bottomMargin ? classes.bottomMargin : '')}
      alignItems='baseline'>
      <Grid item className={classNames(classes.decorator, classes[`h${h}`], classes[color])}></Grid>
      <Grid item className={classes.text}>
        <Typography style={style || {}}
          variant={`h${hLevel}`}
          className={classNames(classes.hText, allCaps ? classes.allCaps : null)}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  )
}

Subtitle.propTypes = {
  /**
   * The message to display
   */
  children: PropTypes.node.isRequired,
  /**
   * Color for the left border
   */
  color: PropTypes.oneOf(['yellow', 'green', 'primary']),
  /**
   * heading level for the message
   */
  hLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /**
   * Should there be a margin-bottom of 16px?
   */
  bottomMargin: PropTypes.bool,
  /**
   * Should the message be title-cased?
   * */
  allCaps: PropTypes.bool,
}

Subtitle.defaultProps = {
  color: 'primary',
  hLevel: 4,
  bottomMargin: false,
  allCaps: false,
}

export default Subtitle
